<template>
	<div v-loading="loading">
		<div class="search">
			<el-form class="searchform" ref="form" :model="searchform" label-width="80px" label-position="left">
				<el-form-item label="快速搜索">
					<el-input placeholder="請輸入員工賬號/姓名/電話等......" v-model="searchform.keyword">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</el-form-item>
			</el-form>


		</div>
		<div class="pagemain">
			<div class="pagetablebox">
				<el-table @selection-change="selectuser" ref="chooseusertable" empty-text="暫無數據" :data="userdata" border
				 :header-cell-style="{background:'#FAFAFA'}">
					<el-table-column type="selection" width="40"></el-table-column>
					<el-table-column prop="username" label="用戶名" align="center"></el-table-column>
					<el-table-column prop="name" label="姓名" align="center"></el-table-column>
					<el-table-column prop="email" label="郵箱" align="center"></el-table-column>
					<el-table-column prop="phone" label="電話" align="center"></el-table-column>
					<el-table-column sortable prop="sex" label="性別" align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.sex == 0">男</div>
							<div v-else>女</div>
						</template>
					</el-table-column>
					<el-table-column sortable prop="age" label="年齡" align="center"></el-table-column>
					<el-table-column sortable prop="status" label="狀態" align="center">
						<template slot-scope="scope">
							<el-switch disabled="" v-model="scope.row.status" active-text="啟用" inactive-text="禁用"></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button size="mini" @click="choose(scope.row.id)">單選</el-button>
						</template>

					</el-table-column>
				</el-table>
			</div>
			<div style="margin-top: 20px">
				<div class="mm-row">
					<el-button @click="clearchoose()">取消选择</el-button>
					<el-button type="primary" @click="allchoose()">批量選擇</el-button>

				</div>

			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "chooseuser",
		props: ['store_id'],
		data() {
			return {
				loading: false,
				userdata: [],
				searchform: {},
				chooseids: []
			}
		},

		methods: {
			selectuser(row) {
				this.chooseids = [];
				if (row.length > 0) {
					row.map((v) => {
						this.chooseids.push(v.id);
					})
				}
			},
			choose(user_id) {
				if(user_id>0){
					let store_id = this.store_id;
					this.loading = true;
					this.post('/api/store/chooseoneusersave', {
						store_id:this.store_id,
						user_id:user_id
					}).then((res) => {
						this.$emit('closedialog');
						this.loading = false;
					}).catch((err) => {
						this.loading = false;
						console.log(err)
					});
				}
			},
			allchoose() {
				let userids = this.chooseids;
				if(userids.length>0){
					let store_id = this.store_id;
					this.loading = true;
					this.post('/api/store/chooseusersave', {
						store_id:this.store_id,
						userids:userids
					}).then((res) => {
						this.$emit('closedialog');
						this.loading = false;
					}).catch((err) => {
						this.loading = false;
						console.log(err)
					});
				}
			},
			clearchoose() {
				this.$refs.chooseusertable.clearSelection();
			},
			
			getuserdata() {

				this.loading = true;
				this.post('/api/store/chooseuser', {
					store_id:this.store_id
				}).then((res) => {
					
					res.map((v) => {
						if (v.status == 0) {
							v.status = true;
						} else if (v.status == 1) {
							v.status = false;
						}
					})
					this.userdata = res;

					this.loading = false;
				}).catch((err) => {
					this.loading = false;
					console.log(err)
				});
			}
		},
		created() {
			this.getuserdata();
		}




	}
</script>

<style>


</style>
